import { render, staticRenderFns } from "./ProviderReferrals.vue?vue&type=template&id=1e8b7c88"
import script from "./ProviderReferrals.vue?vue&type=script&lang=js"
export * from "./ProviderReferrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports